import { render, staticRenderFns } from "./postdetail.vue?vue&type=template&id=cdf0acfc&"
import script from "./postdetail.vue?vue&type=script&lang=js&"
export * from "./postdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports